import config from "config";
import { SORT_OPTIONS_CHANGE } from "actions/const";

function reducer(state = config.state.sortOptions, action) {
  if (action.type === SORT_OPTIONS_CHANGE) {
    return {
      ...state,
      sortOptions: action.sortOptions,
    };
  }
  return state;
}
export default reducer;
